import { useState, useEffect, useRef } from 'react';
import '../../../entrydoor.css';
import { formatToDecimal, formatToFractional } from '../../../controls/conversions';

const calcWidth = (doorTypeId, doorSizeValue) => {
  const w = parseInt(doorSizeValue);
  if (!w) return '';
  if (doorTypeId === 1) return `${w + 1} 1/2"`;
  if ([2, 3].includes(doorTypeId)) return `${w + 17}"`;
  if (doorTypeId === 4) return `${w + 32} 1/2"`;
  if (doorTypeId === 5) return `${w * 2 + 2}"`;
  if ([6, 7].includes(doorTypeId)) return `${w * 2 + 17} 1/2"`;
  if (doorTypeId === 8) return `${w * 2 + 33}"`;
  return '';
};

const FrameWidth = ({ value = { value: '', label: '' }, onChange, disabled = false, doorSize, selectedDoor }) => {
  const [selected, setSelected] = useState(value?.value || '');
  const [error,    setError]    = useState('');
  const skipValueSync = useRef(false); // prevents value-prop sync from fighting auto-calc

  // Auto-calculate when doorSize or selectedDoor changes
  useEffect(() => {
    if (selectedDoor?.id && doorSize?.value) {
      const calc = calcWidth(selectedDoor.id, doorSize.value);
      if (calc) {
        skipValueSync.current = true;
        setSelected(calc);
        onChange({ value: calc, label: calc });
      }
    }
  }, [doorSize?.value, selectedDoor?.id]);

  // Sync from parent only when value changes externally (e.g. load from DB)
  useEffect(() => {
    if (skipValueSync.current) { skipValueSync.current = false; return; }
    setSelected(value?.value || '');
  }, [value?.value]);

  const validate = (v) => {
    const min = selectedDoor?.id > 4 ? 40 : 24;
    const max = selectedDoor?.id > 4 ? 80 : 40;
    const num = parseFloat(formatToDecimal(v));
    if (v && !isNaN(num) && (num < min || num > max)) {
      setError(`Frame Width must be between ${min}" and ${max}"`);
    } else {
      setError('');
    }
  };

  const handleChange = (e) => {
    const v = e.target.value;
    setSelected(v);
    validate(v);
  };

  const handleFocus = (e) => {
    const dec = formatToDecimal(e.target.value);
    setSelected(dec === '0' || dec === 0 ? '' : dec);
  };

  const handleBlur = (e) => {
    const formatted = formatToFractional(e.target.value);
    setSelected(formatted);
    onChange({ value: formatted, label: formatted });
  };

  return (
    <div className="a-container">
      <label htmlFor="SdFrameWidth">Frame Width</label>
      <input
        id="SdFrameWidth"
        value={selected}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        disabled={disabled}
        placeholder='e.g. 33 1/2"'
      />
      {error && <p className="error">{error}</p>}
    </div>
  );
};

export default FrameWidth;
